<template>
  <div :class="{ 'next-background': mode === 'home' }">
    <mainindex>
      <div
        v-if="!islogmode"
        class="content"
      >
        <!--<div class="content" v-if="gen._UID && !islogmode">-->
        <!--HEADER-->
        <page-header
          v-if="mode !== 'home'"
          :menu-tree="menu"
          :cur-page="mode"
          @nav="go($event)"
          @save-prj="savePrj()"
          @clone-prj="cloneProject()"
          @new-prj="newPrj"
          @openlogspanel="toggleLogsPanel"
        ></page-header>
        <!--HEADER-->
        <!--BODY-->
        <div class="body" :class="[paddingClass]">
          <router-view v-if="$route.name !== null"></router-view>
          <div v-else>
            <template v-if="mode==='home' && $route.name !== 'guestRegister' && $route.name !== 'resetPassword' && $route.name !== 'guestResetPassword'">
              <home
                @new-prj="newPrj"
                @load-prj="!user.guest ? go('projects.my') : go('projects.guest')"
                @nav="go($event)"
              ></home>
            </template>
            <template v-else-if="mode==='startprj'">
              <start-prj @nav="go($event)"></start-prj>
            </template>
            <template v-else-if="mode==='projects.guest' && user.guest">
              <prj-finder
                key="CUSTOMER"
                filter="GUEST"
                title="My Projects"
                :rows-number="5"
                order-by="11D"
                :cols="[
                { id:'guest.fullname', title:_trans('customer name'), order:5 },
                { id:'id', title:'id', order:0 },
                { id:'des', title:'name', order:6 },
                { id:'shop', title:'shop', order:8 },
                { id:'status', title:'status', order:4 },
                { id:'lastedit', title:'last edit', order:11}
              ]"
                @open="openPrj($event)"
              ></prj-finder>
            </template>
            <template v-else-if="mode==='projects.my' && !user.guest">
              <prj-finder
                key="MY"
                filter="MY"
                title="My Projects"
                :rows-number="5"
                order-by="11D"
                :cols="getCols(true, true)"
                @open="openPrj($event)"
              ></prj-finder>
            </template>
            <template v-else-if="mode==='projects.ext' && !user.guest">
              <prj-finder
                key="OTHERPRJ"
                filter="OTHERPRJ"
                title="Other Projects In My Store"
                :rows-number="5"
                order-by="11D"
                :cols="getCols(false)"
                @open="openPrj($event)"
              ></prj-finder>
            </template>
            <template v-else-if="mode==='projects.clinv' && !user.guest">
              <prj-finder
                key="CLOSED"
                filter="CLOSED"
                title="Closed Projects"
                :rows-number="5"
                order-by="11D"
                :cols="getCols(false)"
                @open="openPrj($event)"
              ></prj-finder>
              <prj-finder
                key="INACTIVE"
                filter="INACTIVE"
                title="Inactive Projects"
                :rows-number="5"
                order-by="11D"
                :cols="getCols(false)"
                @open="openPrj($event)"
              ></prj-finder>
            </template>
            <template v-else-if="mode==='notifications'">
              <notifications></notifications>
            </template>
            <template v-else-if="mode==='itemsearch'">
              <article-search @nav="go($event)"></article-search>
            </template>
            <template v-else-if="mode === 'renders'">
              <renders @nav="go($event)" />
            </template>
            <template v-else-if="mode==='configurator'">
              <configure
                :update-picture="false"
                @nav="go($event)"
              ></configure>
            </template>
            <template v-else-if="mode==='3dview' || mode === 'planner'">
              <view3d
                :load-header-on-start="true"
                @nav="go($event)"
              />
            </template>
            <template v-else-if="mode==='2dview'">
              <view2d
                :load-header-on-start="true"
                @nav="go($event)"
              />
            </template>
            <template v-else-if="mode==='compositions'">
              <compositions
                :apply-header="true"
                @nav="go($event)"
              />
            </template>
            <template v-else-if="mode==='offerview'">
              <offer @nav="go($event)"></offer>
            </template>
            <template v-else-if="mode==='summary'">
              <prj-summary @nav="go($event)" />
            </template>
            <template v-else-if="mode==='customerinfo'">
              <customer-info @nav="go($event)" />
            </template>
            <template v-else-if="mode==='prjlog'">
              <prj-log @nav="go($event)" />
            </template>
            <template v-else-if="mode==='delivery'">
              <delivery @nav="go($event)" />
            </template>
            <template v-else-if="mode==='promotions'">
              <promotions @nav="go($event)" />
            </template>
            <template v-else-if="mode === 'myprofile'">
              <my-profile @nav="go($event)" />
            </template>
            <template v-else-if="mode==='json'">
              <d-json :value="prj" />
            </template>
            <template v-else>
              <h1>::::{{ mode }}::::</h1>
            </template>
          </div>
        </div>
        <!--BODY-->
      </div>
      <home
        v-else
        @new-prj="newPrj"
        @load-prj="go('projects.my')"
        @nav="go($event)"
      ></home>
    </mainindex>
    <app-settings
      v-if="showSettings"
      @close="showSettings = false"
    ></app-settings>
  </div>
</template>
<script>
    import "../../../scss/next.scss";
    import {Dau, bus} from "@store/dau";
    import index from "@configurator/index";
    import {Auth} from "@3cad/nextcore";
    import {customImport} from "@/utils";

    export default {
        mixins: [index],
        components: {
            pageHeader: () => customImport("comp/pageHeaderNew.vue")
        },
        created () {          
          // Attiva la quotatura globale del progetto, messo qui per non creare la 3dview in mixin (non ancora necessaria)
          // Và aggiunto il campo "totalQuote" (true/false) nel config.json.
          this.$store.commit("cad/enableBoundingQuote", this.preferences.config.totalQuote ? true : false);
        },
        data() {
            return {
                menu: require("@assets/next/json/menu.json")
            };
        },
        computed: {
            user() {
              return this.$store.getters['getProfile']              
            },
            paddingClass() {
                switch (this.mode) {
                    case "home":
                        return "no-menu";
                    case "startprj":
                    case "projects":
                    case "projects.my":
                    case "projects.ext":
                    case "projects.clinv":
                        return "mid-menu";
                    default:
                        return "full-menu";
                }
            }
        },
        watch: {
          user: {
            handler: function (newVal) {
              // TODO: Guardare i seguenti link
              // https://en.wikipedia.org/wiki/Language_localisation#Language_tags_and_codes
              // http://www.rfc-editor.org/rfc/bcp/bcp47.txt#
              // https://www.w3.org/International/articles/language-tags/
              if (newVal.shop && newVal.shop.country.toUpperCase() === "US") {
                // this.preferences.config.measures.length = "EX";
                // this.preferences.config.measures.volume = "CI";
                // this.preferences.config.measures.weight = "LB";
                this.preferences.config.currency = "USD";
              } else if (newVal.shop && newVal.shop.country.toUpperCase() === "CA") {
                this.preferences.config.measures.length = "EX";
                this.preferences.config.measures.volume = "CI";
                this.preferences.config.measures.weight = "LB";
                this.preferences.config.currency = "CAD";
              } else if (newVal.shop && newVal.shop.country.toUpperCase() === "GB") {
                //  this.preferences.config.measures.length = 'EX';
                //  this.preferences.config.measures.volume = 'CI';
                //  this.preferences.config.measures.weight = 'LB';
                // this.preferences.config.currency = "GBP";
              } else if (newVal.shop && newVal.shop.country.toUpperCase() === "UK") {
                // this.preferences.config.measures.length = 'EX';
                // this.preferences.config.measures.volume = 'CI';
                // this.preferences.config.measures.weight = 'LB';
                // this.preferences.config.currency = "GBP";
              } else if (newVal.shop && newVal.shop.country.toUpperCase() === "EN") {
                // this.preferences.config.measures.length = 'EX';
                // this.preferences.config.measures.volume = 'CI';
                // this.preferences.config.measures.weight = 'LB';
                // this.preferences.config.currency = "GBP";
              } else if (newVal.shop && newVal.shop.country.toUpperCase() === "CH") {
                this.preferences.config.currency = "CHF";
              } else if (newVal.shop && newVal.shop.country.toUpperCase() === "JP") {
                this.preferences.config.currency = "JPY";
              } else {
                this.preferences.config.measures.length = "MM";
                this.preferences.config.measures.volume = "CR";
                this.preferences.config.measures.weight = "KG";
                this.preferences.config.currency = "EUR";
              }
            },
            deep: true
          }
        },
        methods:{
          cloneProject() {
      this.$store.dispatch("project/save", { clone: false }).then((res) => {
        this.$store.commit("resetLoading");
        var title = "copia - " + (this.prj.des != "" ? this.prj.des : this.prj.id);
        this.$ApraAsk({
          title: this._trans("Attenzione"),
          body: this._trans("Sicuro di voler duplicare il progetto?"),
        })
          .then((data) => {
            bus.$emit("startLoading", this._trans("Cloning project"));
            return new Promise((resolve, reject) => {
              this.$store.dispatch("project/save", { clone: true }).then((res) => {
                this.$store.commit("resetLoading");
                this.prj.des = title;
                this.$store.dispatch("project/save", { clone: false }).then((res) => {
                  this.$store.commit("resetLoading");
                  bus.$emit("savedPrj");
                  resolve();
                });
              });
            });
          })
          .catch((mode) => {});
      });
    },openPrj(id) {
            return new Promise(resolve=>{
              var vm = this;
                let loadPrj = () => {
                    if (localStorage['next_goto']) {
                        delete localStorage['next_goto'];
                    }
                    bus.$emit('startLoading', this._trans('Loading project'));
                    this.resetCustomerParams();
                    this.$store.dispatch('project/load', {id: id}).then((prj) => {
                      this._checkOldWalls().then(() => {
                        this.pricesIncrease = prj.pricesIncrease;
                        if (this.$store.state.searchArticle)
                        this.$store.unregisterModule('searchArticle');


                        /*Auth.setShop(vm.user.shop.cod).then(newProfile => {
                            this.$store.commit("setProfile", newProfile);
                            //this.shopChanged();

                            bus.$emit('stopLoading');
                            this.onProjectLoaded();
                            resolve();
                        });*/


                        prj.listid = vm.user.shop.pricelist;
                        bus.$emit('stopLoading');
                        this.onProjectLoaded();
                        resolve();   
                      }).catch(() => {
                          bus.$emit('stopLoading');
                      });
                    });
                };

                if (this.prj.isopen) {
                    this.$3cadAsk({
                        title: this._trans('Project not saved'),
                        body: this._trans('Save current project?'),
                        okTitle: this._trans('Yes'),
                        cancelTitle: this._trans('No')
                    }).then(data => {
                      this.$store.dispatch('project/setStatus', {
                            prjId: id,
                            status: "ASSIGNED",
                            toShop: vm.user.shop.cod,
                            toUser: vm.user.userID
                        }).then(() => {
                          this.savePrj().then(loadPrj);
                        })
                    }).catch(mode => {
                        if (mode === 0) {
                        this.$store.dispatch('project/setStatus', {
                            prjId: id,
                            status: "ASSIGNED",
                            toShop: vm.user.shop.cod,
                            toUser: vm.user.userID
                        }).then(() => {
                            loadPrj()
                        })
                        }
                    });
                } else {
                        this.$store.dispatch('project/setStatus', {
                            prjId: id,
                            status: "ASSIGNED",
                            toShop: vm.user.shop.cod,
                            toUser: vm.user.userID
                        }).then(() => {
                            loadPrj()
                        })
                }
            })

        },
          onNewProject(assignCustomer = false) {
            this.$set(this.prj, "currency", this.preferences.config.currency || "EUR");
            this.$set(this.prj, "extra2", 0);
            this.$set(this.prj, "discountamount", 0);
            this.go("itemsearch");
          },
          getCols(withAssign=false, withDelete = false){
            var cols = [
                { id: 'guest.fullname', title: this._trans('customer name'), order: 5 },
                { id: 'id', title: 'id', order: 0 },
                { id: 'des', title: 'name', order: 6 },
                { id: 'shop', title: 'shop', order: 8 },
                { id: 'status', title: 'status', order: 4 },
                { id: 'lastedit', title: 'last edit', order: 11 },              
              ]
              if(withAssign || this.user.seller == 6){
                 cols = [...cols,({ id: 'assign', title: null })];
              }

              if(withDelete || this.user.seller == 6){
                 return [...cols,({ id:'delete', title:null })];
              }
              return cols;
          }
        }
    };
</script>
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/custom/officinefanesi/start.vue